import React from "react";
import "../assets/styles/About.scss";

function About() {
  return (
    <div className="container" id="about">
      <div className="about-container">
        <span className="about-tag">{'// About Me'}</span>
        <h1>The person behind the infrastructure.</h1>
        <div className="about-body">
          <p>
            Cloud Infrastructure Engineer and AWS Solutions Architect based in Berlin, Germany.
            I've spent 8+ years in the deep end of cloud infrastructure — not just deploying things,
            but designing the platforms that engineering teams build on. My work spans fintech,
            telecommunications, and cloud-native product engineering, with a focus on AWS, Kubernetes,
            and the networking layer that ties it all together.
          </p>
          <p>
            I specialize in the problems most teams find hardest: EKS at scale, custom Kubernetes
            networking (Envoy, CNI plugins), multi-region architectures, FinOps optimization,
            and compliance-grade infrastructure. Currently building carrier-grade packet gateway
            infrastructure at Emnify in Berlin. Previously, I owned the full AWS stack and Kubernetes
            platform at a fintech company — including PCI-DSS compliance, GitOps pipelines,
            and FinOps strategy.
          </p>
          <p className="about-closing">
            I don't just deploy infrastructure. I design platforms that teams can own and operate
            long after I'm gone.
          </p>
        </div>
      </div>
    </div>
  );
}

export default About;
